export default {"src":"/_next/static/media/Room3.6e4d9223.svg","height":285,"width":330,"blurWidth":0,"blurHeight":0};